<template>
        <div>
          <el-input
              v-model="localValue"
              placeholder="请输入"
              :clearable="true"
              v-if="type === 0"
          ></el-input>
          <el-switch
              v-if="type === 20"
              v-model="localValue"
              active-value="1"
              inactive-value="0"
              active-text="启用"
              inactive-text="停用">
          </el-switch>
          <el-input-number    v-if="type === 21" v-model="localValue"></el-input-number>
          <el-input v-if="type === 22"
                    v-model="localValue"
                    :autosize="{ minRows: 2, maxRows: 10}"
                    type="textarea"
                    placeholder="输入内容"
          />
          <!-- 富文本 -->
          <div class="ql-editor" v-if="type === 23" >
            <quill-editor
                ref="introductionQuillEditor"
                v-model="localValue"
                :options="editorOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @ready="onEditorReady($event)"
            />
            <div class="simulator infinite-list-wrapper" style="overflow:auto" >
              <div style="word-wrap: break-word; word-break: normal; " v-html="localValue">

              </div>
            </div>
          </div>
          <!-- 上传图片 -->
          <uploadImg
              v-if="type === 24"
              v-model="localValue"
              :max="1"
              :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
          ></uploadImg>
          <!-- 上传文件 -->
          <uploadFile
              v-if="type === 25"
              v-model="localValue"
              :max="1"
              :text="['文件大小500M以内']"
          ></uploadFile>

          <el-select
                  filterable
                  reserve-keyword
              v-if="type === 3"
              clearable
              class="filter-item"
              v-model="localValue"
              placeholder="请选择优惠券"
              style="margin-right: 20px;"
          >
            <el-option
                v-for="item in couponsList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
          <el-select
                  filterable
                  reserve-keyword
              v-if="type == 5"
              clearable
              class="filter-item"
              v-model="localValue"
              placeholder="请选择抽奖"
              style="margin-right: 20px;"
          >
            <el-option
                v-for="item in rafflesList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
          <el-select
                  filterable
                  reserve-keyword
              v-if="type == 6"
              clearable
              class="filter-item"
              v-model="localValue"
              placeholder="请选择勋章"
              style="margin-right: 20px;"
          >
            <el-option
                v-for="item in medalsList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
          <el-select    filterable
                        reserve-keyword v-model="localValue" placeholder="请选择属性" v-if="type == 7">
            <el-option-group v-for="group in options" :key="group.label" :label="group.label">
              <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
          <el-select
                  filterable
                  reserve-keyword
              v-if="type == 8"
              clearable
              class="filter-item"
              v-model="localValue"
              placeholder="请选择委托"
              style="margin-right: 20px;"
          >
            <el-option
                v-for="getCR in getCRsList"
                :key="getCR.id"
                :label="getCR.name"
                :value="getCR.id"
            ></el-option>
          </el-select>
          <el-select
                  filterable
                  reserve-keyword
              v-if="type == 9"
              clearable
              filterable
              class="filter-item"
              v-model="localValue"
              placeholder="请选择打卡任务"
              style="margin-right: 20px;"
          >
            <el-option
                v-for="getCR in getsThemeList"
                :key="getCR.id"
                :label="getCR.title"
                :value="getCR.id"
            ></el-option>
          </el-select>
          <el-select
                  filterable
                  reserve-keyword
              v-if="type == 10"
              clearable
              class="filter-item"
              v-model="value2"
              placeholder="请选择委托"
              style="margin-right: 20px;"
              @change="function(e){
              skusType(e)
            }"
          >
            <el-option
                v-for="getCR in getCRsList"
                :key="getCR.id"
                :label="getCR.name"
                :value="getCR.id"
            ></el-option>
          </el-select>
          <el-select

              v-if="type === 10"
              clearable
              class="filter-item"
              v-model="localValue"
              placeholder="请选择委托卡片"
              style="margin-right: 20px;"
              :disabled="value2 == ''"
          >
            <el-option
                v-for="getCR in prizs.getCardList"
                :key="getCR.id"
                :label="getCR.companyName + ' -酬劳:'+getCR.reward"
                :value="getCR.id"
            ></el-option>
          </el-select>
          <el-select
                  filterable
                  reserve-keyword
              v-if="type == 11"
              clearable
              class="filter-item"
              v-model="localValue"
              placeholder="请选择大赛"
              style="margin-right: 20px;"
          >
            <el-option
                v-for="item3 in megagameList"
                :key="item3.id"
                :label="item3.title"
                :value="item3.id"
            ></el-option>
          </el-select>
          <el-select
                  filterable
                  reserve-keyword
              v-if="type == 12"
              clearable
              class="filter-item"
              v-model="localValue"
              placeholder="请选择地图"
              style="margin-right: 20px;"
          >
            <el-option
                v-for="item3 in mapList"
                :key="item3.id"
                :label="item3.name"
                :value="item3.id"
            ></el-option>
          </el-select>
          <el-select

              v-if="type == 14"
              v-model="localValue"
              filterable
              remote
              reserve-keyword
              placeholder="搜素关键词"
              :remote-method="getKeywordList"
              :loading="replyOptionLoading"
          >
            <el-option
                v-for="option in keywordList"
                :key="option.key"
                :label="option.value"
                :value="option.key"
            />
          </el-select>
        </div>
</template>
<script>
import { getArrList } from '@/api/demo/discount/index'
import { getLuckList } from '@/api/demo/luckDraw/index'
import { getMedalList } from '@/api/demo/medal/index'
import { attList } from '@/api/demo/attributes/index'
import { getCRList, getCard } from '@/api/demo/CommissionRelate/index'
import uploadImg from '@/components/uploadImage/index.vue'
import uploadFile from '@/components/uploadFile/index.vue'
import { getThemeList } from '@/api/demo/punchInActivity/index'
import { megagameList } from '@/api/demo/competition/index'
import { getMapList } from '@/api/demo/map/index'

/**
 * 富文本工具
 */
import { quillEditor, Quill } from 'vue-quill-editor'
import { replayContent, initEditor, option, initTitle } from '@/utils/editor'
import { replyKeywordOption } from '@/api/demo/helper'
initEditor(Quill)
export default {
  name: 'inputValue',
  props: {
    type: Number,
    value: Number | String
  },
  components: {
    uploadImg,
    uploadFile
  },
  data () {
    return {
      editorOption: option,
      value2: '',
      localValue: this.value,
      couponsList: [], // 优惠券列表
      rafflesList: [], // 抽奖列表
      medalsList: [], // 勋章列表
      getCRsList: [], // 委托管理
      getsThemeList: [],
      megagameList: [],
      keywordList: [],
      replyOptionLoading: false,
      mapList: [],
      options: [
        { label: '亲密关系', options: [] },
        { label: '气质特征', options: [] },
        { label: '能力属性', options: [] },
        { label: '影响力', options: [] }
      ]

    }
  },
  created () {
    console.log('type', this.type)
    this.initData()
  },

  watch: {
    localValue (newValue) {
      this.$emit('update:value', newValue)
    },
    type (newValue) {
      this.type = newValue
      this.initData()
    },
    value (newValue) {
      this.localValue = newValue
    }
  },
  methods: {
    initData () {
      let that = this
      let type = this.type
      if (type === 3) {
        that.couponList()
      }
      if (type === 5) {
        that.raffleList()
      }
      if (type === 6) {
        that.medalList()
      }
      if (type === 10) {
        that.getCRList()
      }
      if (type === 11) {
        that.getMegagameList()
      }
      if (type === 12) {
        that.getMapList()
      }
      if (type === 7) {
        that.getAttributes()
      }
      if (type === 9) {
        that.getThemesList()
      }

      if (type === 14) {
        that.getKeywordList()
      }
    },
    getKeywordList (keyword) {
      let that = this
      let query = { 'keyword': keyword }
      that.replyOptionLoading = true
      replyKeywordOption(query).then(res => {
        that.keywordList = res
      }).finally(() => {
        that.replyOptionLoading = false
      })
    },
    // 大赛
    getMegagameList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        classifyId: ''
      }
      megagameList(listQuery).then(res => {
        that.megagameList = res.records
      })
    },
    getMapList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 1000,
        keyword: '',
        classifyId: ''
      }
      getMapList(listQuery).then(res => {
        that.mapList = res.records
      })
    },
    changes (e) {
      console.log('prizs', this.prizs)
    },
    // 类型
    skuType (e) {
      let that = this
      that.prizs.type = e
    },
    // 卡片列表
    getCardsList (e) {
      let that = this
      getCard(e).then(res => {
        that.prizs.getCardList = res
      })
    },
    skusType (e) {
      let that = this
      if (e == '') {
      } else {
        that.getCardsList(e)
      }
    },
    validateEmail (str) {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      return reg.test(str)
    },
    // 获取打卡任务
    getThemesList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 9999,
        classifyId: null,
        keyword: null,
        status: 1
      }
      getThemeList(listQuery).then(res => {
        that.getsThemeList = res.records
      })
    },
    // 优惠券
    couponList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 9999,
        keyword: '',
        stat: 1,
        type: ''
      }
      getArrList(listQuery).then(res => {
        that.couponsList = res.records
      })
    },
    // 抽奖列表
    raffleList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        name: null, // 名称
        pageSize: 200, // 每页显示的大小
        status: 1 // 状态
      }
      getLuckList(listQuery).then(res => {
        that.rafflesList = res.records
      })
    },
    // 勋章列表
    medalList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200 // 每页显示的大小
      }
      getMedalList(listQuery).then(res => {
        that.medalsList = res.records
      })
    },
    getCRList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200, // 每页显示的大小
        status: 1
      }
      getCRList(listQuery).then(res => {
        that.getCRsList = res.records
      })
    },
    // 获取属性相关
    getAttributes () {
      let listQuery = {
        currentPage: 1,
        pageSize: 100
      }
      attList(listQuery, 1).then(res => {
        res.records.forEach(item => {
          this.options[0].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 2).then(res => {
        res.records.forEach(item => {
          this.options[1].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 4).then(res => {
        res.records.forEach(item => {
          this.options[2].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
    },
    onEditorBlur (quill) {
      console.log('editor blur!', this.form.content, quill)
    },
    onEditorFocus (quill) {
      console.log('editor focus!', this.form.content, quill)
    },
    onEditorReady (quill) {
      console.log('editor ready!', quill)
    }
  }
}
</script>
